<div class="modal-header">
  <h4 uni-heading color="primary" class="modal-title" id="exampleModalScrollableTitle">Subir Documentos</h4>
  <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="closeModal()">
    <uni-icon name="x"></uni-icon>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="modal-container-spacer">
      <ngx-file-drop
        [accept]="getAcceptedFormat"
        [multiple]="true"
        (onFileDrop)="onFileDrop($event)"
        dropZoneLabel="Agregar documentos"
        [showBrowseBtn]="true"
      >
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <div class="ctr-select-documents">
            Arrastrar Documentos Aquí
            <button type="button" (click)="openFileSelector()" style="display: none" id="btn-select-documents">
              Seleccionar Documentos
            </button>
          </div>
        </ng-template>
      </ngx-file-drop>
      <div
        style="display: flex; justify-content: center; align-items: center; margin: 0; padding: 15px 0px; box-sizing: border-box"
      >
        <button type="button" (click)="clickBtnSelectFiles()" class="btn-select-documents" id="btn-select-documents-2">
          Seleccionar Documentos
        </button>
      </div>
    </div>
    <br />

    <ng-container *ngIf="files.length || newFilesUpload.length">
      <h4 class="title">
        <span class="title-span-number">{{ filesUpload?.length ?? 0 }} </span>&nbsp;
        {{ (filesUpload?.length ?? 0) == 1 ? "Documento subido" : "Documentos subidos" }}:&nbsp;
        <span class="title-span-size">{{ filesFullSizeMegaBytesRounded }} mbs</span>
      </h4>

      <div class="ctr-selection-options">
        <ng-container *ngIf="this.newFilesUpload.length">
          <button *ngIf="!ifEveryNewFileIsSelected()" class="btn btn-info" (click)="setSelectedFilesAll()" id="btn-select-all">
            Seleccionar todos&nbsp;&nbsp;<b>{{ this.newFilesUpload.length }}</b>
          </button>
        </ng-container>
        <ng-container *ngIf="this.selectedFiles.length">
          &nbsp;&nbsp;
          <button class="btn btn-warning" (click)="removeSelectedFiles(false)" id="btn-unselect-all">
            Deseleccionar archivos&nbsp;&nbsp;<b>{{ this.selectedFiles.length }}</b>
          </button>
          &nbsp;&nbsp;
          <button class="btn btn-danger" (click)="removeSelectedFiles()" id="btn-remove-selected">
            Remover archivos&nbsp;&nbsp;<b>{{ this.selectedFiles.length }}</b>
          </button>
        </ng-container>
      </div>

      <div class="ctr-uploaded-files-list">
        <table style="width: 100%">
          <caption></caption>
          <thead>
            <tr style="border-bottom: 2px solid rgba(0, 0, 0, 0.05)">
              <th colspan="4"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let file of newFilesUpload; index as i">
              <tr class="{{ inputFileIdentifier }}-{{ i }}-rows">
                <td colspan="1" rowspan="2" style="width: 30px; text-align: center; vertical-align: middle">
                  <input
                    type="checkbox"
                    name="{{ inputFileIdentifier }}-{{ i }}"
                    class="{{ inputFileIdentifier }}"
                    id="{{ inputFileIdentifier }}-{{ i }}"
                    (click)="setSelectedFiles(file.file, $event)"
                    (keypress)="onKeyPressCheck(setSelectedFiles.bind(this, file.file, $event), $event)"
                    style="position: relative"
                  />
                </td>
                <td colspan="2">
                  <b style="font-size: 14px; font-weight: 300">
                    {{ fileNameToName.bind(this, file.file)() }} - {{ fileNameToExtension.bind(this, file.file)() }}
                  </b>
                </td>
                <td colspan="1" rowspan="2" style="text-align: center; vertical-align: middle">
                  <div style="display: flex; justify-content: flex-end; align-items: center; height: 100%">
                    <button
                      type="button"
                      class="delete-icon"
                      (click)="removeFile(file.file)"
                      id="{{ inputFileIdentifier }}-{{ i }}-btn-remove"
                    ></button>
                  </div>
                </td>
              </tr>
              <tr
                class="{{ inputFileIdentifier }}-{{ i }}-rows {{ inputFileIdentifier }}-{{ i }}-rows-last"
                style="border-bottom: 2px solid rgba(0, 0, 0, 0.05)"
              >
                <td colspan="2">
                  <span style="font-size: 12px; font-weight: 300">{{ getFileSizeMegaBytes.bind(this, file.file, 3)() }} mbs</span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngFor="let file of files">
              <tr>
                <td colspan="3">
                  <b style="font-size: 14px; font-weight: 300">
                    {{ fileNameToName.bind(this, file.file)() }} - {{ fileNameToExtension.bind(this, file.file)() }}
                  </b>
                </td>
                <td colspan="1" rowspan="2" style="text-align: center; vertical-align: middle">
                  <div style="display: flex; justify-content: flex-end; align-items: center; height: 100%">
                    <button type="button" class="delete-icon" style="background-color: rgba(0, 0, 0, 0.05)"></button>
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 2px solid rgba(0, 0, 0, 0.05)">
                <td colspan="2">
                  <span style="font-size: 12px; font-weight: 300">{{ getFileSizeMegaBytes.bind(this, file.file, 3)() }} mbs</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="onSave()" id="btn-save">Guardar</button>

  <button uni-button fill="outline" variant="secondary" (click)="onCancel()" id="btn-cancel">Cancelar</button>
</div>
